module.exports = __webpack_public_path__ + "static/media/Import.e5fd5d61.svg";